import {
    HOME_HEADER_SUBTITLE,
    HOME_HEADER_TITLE,
    HOME_HELMET_DESCRIPTION,
    HOME_HELMET_TITLE,
    HOME_RATE_US,
    HOME_SERVICES_HEADER_TITLE,
    HOME_HERO_EYEBROW,
    HOME_HERO_TITLE_LINE1,
    HOME_HERO_TITLE_ACCENT,
    HOME_HERO_TITLE_LINE2,
    HOME_HERO_SUBTITLE,
    HOME_HERO_CTA_PRIMARY,
    HOME_HERO_CTA_SECONDARY,
    HOME_HERO_TRUST_RATING,
    HOME_HERO_TRUST_BILINGUAL,
    HOME_HERO_TRUST_LOCAL,
    HOME_HERO_STAT_YEARS_VALUE,
    HOME_HERO_STAT_YEARS_LABEL,
    HOME_HERO_STAT_FAMILIES_VALUE,
    HOME_HERO_STAT_FAMILIES_LABEL,
    HOME_HERO_STAT_SERVICES_VALUE,
    HOME_HERO_STAT_SERVICES_LABEL,
    HOME_HERO_VIDEO_BADGE,
    HOME_SERVICES_EYEBROW,
    HOME_SERVICES_TITLE,
    HOME_SERVICES_SUBTITLE,
    HOME_SERVICES_CTA,
    HOME_SERVICES_LINK_UNEMPLOYMENT,
    HOME_SERVICES_DESC_UNEMPLOYMENT,
    HOME_SERVICES_DESC_NOTARY,
    HOME_INTAKE_EYEBROW,
    HOME_INTAKE_TITLE,
    HOME_INTAKE_SUBTITLE,
    HOME_INTAKE_FORM_TAX,
    HOME_INTAKE_FORM_IMM,
    HOME_INTAKE_FORM_INS,
    HOME_INTAKE_FORM_APT,
    OFFICES_EYEBROW,
    OFFICES_TITLE,
    OFFICES_SUBTITLE,
    OFFICES_HOURS_TITLE,
    OFFICES_ADDRESS_TITLE,
    OFFICES_BTN_DIRECTIONS,
    OFFICES_BTN_CALL,
    OFFICES_TODAY_BADGE,
    OFFICES_CLOSED_LABEL,
    OFFICES_STATUS_OPEN_UNTIL,
    OFFICES_STATUS_CLOSING_SOON,
    OFFICES_STATUS_CLOSED_TODAY,
    OFFICES_STATUS_OPENS_AT,
    OFFICES_DAY_MON,
    OFFICES_DAY_TUE,
    OFFICES_DAY_WED,
    OFFICES_DAY_THU,
    OFFICES_DAY_FRI,
    OFFICES_DAY_SAT,
    OFFICES_DAY_SUN,
    HOME_TESTIMONIALS_EYEBROW,
    HOME_TESTIMONIALS_TITLE,
    HOME_TESTIMONIALS_SUBTITLE,
    HOME_TESTIMONIALS_RATING_LABEL,
    HOME_TESTIMONIALS_CTA,
    HOME_TESTIMONIALS_T1_QUOTE,
    HOME_TESTIMONIALS_T1_NAME,
    HOME_TESTIMONIALS_T1_ROLE,
    HOME_TESTIMONIALS_T2_QUOTE,
    HOME_TESTIMONIALS_T2_NAME,
    HOME_TESTIMONIALS_T2_ROLE,
    HOME_TESTIMONIALS_T3_QUOTE,
    HOME_TESTIMONIALS_T3_NAME,
    HOME_TESTIMONIALS_T3_ROLE,
    HOME_TESTIMONIALS_T4_QUOTE,
    HOME_TESTIMONIALS_T4_NAME,
    HOME_TESTIMONIALS_T4_ROLE,
} from "../types";

const en_home_page = {
    helmet: {
        [HOME_HELMET_TITLE]: "Linares Professional Family Services Corp",
        [HOME_HELMET_DESCRIPTION]: `Welcome to our family service agency located in Miami, Florida! We are a team of dedicated professionals who are committed to providing the highest quality care and support for families in need.`,
    },
    section: {
        header: {
            [HOME_HEADER_TITLE]: 'Welcome to Linares Professional Family Services Corp',
            [HOME_HEADER_SUBTITLE]: 'Your trusted partner in family services',
            [HOME_RATE_US]: 'Rate us on Google',

            [HOME_HERO_EYEBROW]: 'Trusted family services in Miami Lakes',
            [HOME_HERO_TITLE_LINE1]: 'Real help for',
            [HOME_HERO_TITLE_ACCENT]: 'real families,',
            [HOME_HERO_TITLE_LINE2]: 'all under one roof.',
            [HOME_HERO_SUBTITLE]: 'One trusted office for Taxes, Immigration, Insurance, Credit Education & Coaching, Travel & Family Services — handled by a bilingual team that treats your family like our own. Walk in, call, or book online.',
            [HOME_HERO_CTA_PRIMARY]: 'Book a free consultation',
            [HOME_HERO_CTA_SECONDARY]: 'Call us now',
            [HOME_HERO_TRUST_RATING]: 'Top rated on Google',
            [HOME_HERO_TRUST_BILINGUAL]: 'Bilingual staff — English & Spanish',
            [HOME_HERO_TRUST_LOCAL]: 'Locally owned & operated',
            [HOME_HERO_STAT_YEARS_VALUE]: '10+',
            [HOME_HERO_STAT_YEARS_LABEL]: 'Years serving Miami',
            [HOME_HERO_STAT_FAMILIES_VALUE]: '5,000+',
            [HOME_HERO_STAT_FAMILIES_LABEL]: 'Families helped',
            [HOME_HERO_STAT_SERVICES_VALUE]: '5',
            [HOME_HERO_STAT_SERVICES_LABEL]: 'Services under one roof',
            [HOME_HERO_VIDEO_BADGE]: 'Watch how we help',
        },

        services: {
            [HOME_SERVICES_HEADER_TITLE]: 'Our Services',
            [HOME_SERVICES_EYEBROW]: 'Our services',
            [HOME_SERVICES_TITLE]: 'Everything your family needs, in one place',
            [HOME_SERVICES_SUBTITLE]: 'From your credit score to your next vacation — our bilingual team handles the paperwork, the phone calls and the follow-ups so you don\'t have to.',
            [HOME_SERVICES_CTA]: 'Learn more',
            [HOME_SERVICES_LINK_UNEMPLOYMENT]: 'Unemployment',
            [HOME_SERVICES_DESC_UNEMPLOYMENT]: 'File and manage unemployment claims with step-by-step guidance.',
            [HOME_SERVICES_DESC_NOTARY]: 'Ana Linares has assisted hundreds of families and small businesses throughout South Florida by providing professional tax preparation, business support, insurance guidance, credit education and coaching services, notary services, travel assistance, and family resource solutions. Through trusted partnerships and affiliated service providers, clients also have access to additional specialized services tailored to their individual needs.',
        },

        intake: {
            [HOME_INTAKE_EYEBROW]: 'Ready to begin?',
            [HOME_INTAKE_TITLE]: 'Download the client intake forms',
            [HOME_INTAKE_SUBTITLE]: 'Fill out your form before your appointment and save time at the office. Upload directly to Google Forms or bring a printed copy.',
            [HOME_INTAKE_FORM_TAX]: 'Tax Intake Form',
            [HOME_INTAKE_FORM_IMM]: 'Immigration Intake Form (E&W MultiService LLC)',
            [HOME_INTAKE_FORM_INS]: 'Insurance Quote Request',
            [HOME_INTAKE_FORM_APT]: 'Appointment Request',
        },

        offices: {
            [OFFICES_EYEBROW]: 'Find us',
            [OFFICES_TITLE]: 'Stop by, call, or get directions',
            [OFFICES_SUBTITLE]: 'We\'re in the heart of Miami Lakes — walk-ins welcome during business hours, and you can always book ahead.',
            [OFFICES_HOURS_TITLE]: 'Business hours',
            [OFFICES_ADDRESS_TITLE]: 'Our address',
            [OFFICES_BTN_DIRECTIONS]: 'Get directions',
            [OFFICES_BTN_CALL]: 'Call the office',
            [OFFICES_TODAY_BADGE]: 'Today',
            [OFFICES_CLOSED_LABEL]: 'Closed',
            [OFFICES_STATUS_OPEN_UNTIL]: 'Open now • closes at {{time}}',
            [OFFICES_STATUS_CLOSING_SOON]: 'Closing soon • {{time}}',
            [OFFICES_STATUS_CLOSED_TODAY]: 'Closed today',
            [OFFICES_STATUS_OPENS_AT]: 'Opens {{day}} at {{time}}',
            [OFFICES_DAY_MON]: 'Monday',
            [OFFICES_DAY_TUE]: 'Tuesday',
            [OFFICES_DAY_WED]: 'Wednesday',
            [OFFICES_DAY_THU]: 'Thursday',
            [OFFICES_DAY_FRI]: 'Friday',
            [OFFICES_DAY_SAT]: 'Saturday',
            [OFFICES_DAY_SUN]: 'Sunday',
        },

        testimonials: {
            [HOME_TESTIMONIALS_EYEBROW]: 'Clients trust us',
            [HOME_TESTIMONIALS_TITLE]: 'Families across Miami trust us',
            [HOME_TESTIMONIALS_SUBTITLE]: 'We are proud of the relationships we build. Here is what some of our clients have to say after working with our team.',
            [HOME_TESTIMONIALS_RATING_LABEL]: '4.9 / 5 average rating on Google',
            [HOME_TESTIMONIALS_CTA]: 'See all reviews',
            [HOME_TESTIMONIALS_T1_QUOTE]: 'They walked me through the whole credit coaching process in plain English. In six months my score went up 120 points and I finally qualified for my first home loan. I tell every friend about them.',
            [HOME_TESTIMONIALS_T1_NAME]: 'Orlando S.',
            [HOME_TESTIMONIALS_T1_ROLE]: 'Credit coaching client',
            [HOME_TESTIMONIALS_T2_QUOTE]: 'I had been doing my taxes online for years and always felt I was missing something. Their team found deductions I never knew existed and got me a much bigger refund. Worth every penny.',
            [HOME_TESTIMONIALS_T2_NAME]: 'Ismary L.',
            [HOME_TESTIMONIALS_T2_ROLE]: 'Tax preparation client',
            [HOME_TESTIMONIALS_T3_QUOTE]: 'My immigration paperwork felt impossible until I met them. They explained every form, every deadline, and handled the follow-ups with USCIS. My family is finally together.',
            [HOME_TESTIMONIALS_T3_NAME]: 'Yanet M.',
            [HOME_TESTIMONIALS_T3_ROLE]: 'Immigration services client',
            [HOME_TESTIMONIALS_T4_QUOTE]: 'Booked our whole family vacation through them — flights, hotel and excursions — at a better price than I found online, and zero stress. The bilingual support made all the difference.',
            [HOME_TESTIMONIALS_T4_NAME]: 'Carlos R.',
            [HOME_TESTIMONIALS_T4_ROLE]: 'Travel agency client',
        },
    }
}

export default en_home_page;

